export default __webpack_public_path__ + "static/media/Skup Pula (1).9f72f713.jpg";